export const ACTION_SET_ROAD_INDEX = "road index";
export const ACTION_START_END_DATE = "start end dates";
export const ACTION_SET_ROADS = "set roads";
export const ACTION_SET_USE_BOX = "use box";
export const ACTION_SET_IS_CSV = "is csv";
export const ACTION_SET_ROAD_FILTER = 'set the road filter';
export const ACTION_SET_VERSION = 'set version';
export const ACTION_COORDINATES = "change coordinates";
export const ACTION_SET_WAITING = "set waiting";